import { api } from '@/shared/api/axios';
import { unwrapList, unwrapSingle, unwrapPage } from '@/shared/api/unwrap';

const base = (depId) => `/deployments/${depId}/recommendations`;

export const recommendationsApi = {
  live: (depId) => api.get(`${base(depId)}/live`).then(unwrapList),

  // Paginated: params = { from, to, page, pageSize }. Returns { rows, pagination }.
  historical: (depId, params = {}) =>
    api.get(`${base(depId)}/historical`, { params }).then(unwrapPage),

  detail: (depId, recId) =>
    api.get(`${base(depId)}/${recId}`).then(unwrapSingle),

  submitAction: (depId, recId, { action, comment }) =>
    api.patch(`${base(depId)}/${recId}/action`, { action, comment }).then((r) => r.data),

  addRemark: (depId, recId, comment) =>
    api.post(`${base(depId)}/${recId}/remarks`, { comment }).then((r) => r.data),

  filters: (depId) => api.get(`${base(depId)}/filters`).then(unwrapSingle),
};
